import { getRequest } from '../../../utils/requests';
import config from '../../../config.json';

/**
 * Получить финансовые данные менеджера
 * @param {string} startDate - дата начала (YYYY-MM-DD)
 * @param {string} endDate - дата окончания (YYYY-MM-DD)
 * @returns {Promise<ManagerFinances>}
 */
export const fetchManagerFinances = async (startDate, endDate) => {
  const url = `${config.service}/api/finances/manager`;
  const response = await getRequest(url, {
    params: { startDate, endDate },
  });
  return response.data;
};

/**
 * Получить финансовые данные для администратора
 * @param {string} startDate - дата начала (YYYY-MM-DD)
 * @param {string} endDate - дата окончания (YYYY-MM-DD)
 * @param {number} page - номер страницы (по умолчанию: 1)
 * @param {number} limit - количество записей на странице (по умолчанию: 50)
 * @returns {Promise<AdminFinances>}
 */
export const fetchAdminFinances = async (startDate, endDate, page = 1, limit = 50) => {
  const url = `${config.service}/api/finances/admin`;
  const response = await getRequest(url, {
    params: { startDate, endDate, page, limit },
  });
  return response.data;
};

/**
 * Получить статус отдела
 * @param {string} department - тип отдела (PRODUCTION, ASSEMBLY, DELIVERY, INSTALLATION)
 * @param {string} startDate - дата начала (YYYY-MM-DD)
 * @param {string} endDate - дата окончания (YYYY-MM-DD)
 * @returns {Promise<DepartmentStatus>}
 */
export const fetchDepartmentFinanceStatus = async (
  department,
  startDate,
  endDate
) => {
  const url = `${config.service}/api/finances/department-status`;
  const response = await getRequest(url, {
    params: { department, startDate, endDate },
  });
  return response.data;
};

/**
 * Получить финансовые данные производственного отдела
 * @param {string} startDate - дата начала (YYYY-MM-DD)
 * @param {string} endDate - дата окончания (YYYY-MM-DD)
 * @param {string} departmentType - тип отдела (PRODUCTION, ASSEMBLY, DELIVERY, INSTALLATION)
 * @param {number} page - номер страницы (по умолчанию: 1)
 * @param {number} limit - количество записей на странице (по умолчанию: 50)
 * @returns {Promise<ProductionFinances>}
 */
export const fetchProductionFinances = async (
  startDate,
  endDate,
  departmentType,
  page = 1,
  limit = 50
) => {
  const url = `${config.service}/api/finances/production`;
  const response = await getRequest(url, {
    params: { department: departmentType, startDate, endDate, page, limit },
  });
  return response.data;
};

